import React, { useEffect, useRef } from "react";
import EmojiListItem from "./EmojiListItem";

import "./styles.scss";

const EmojiList = ({emojiList, filteredEmoji, onSelectEmoji, onChangeCategory}) => {
    const listRef = useRef();

    useEffect(() => {
        if (!listRef.current) return;

        listRef.current.addEventListener('scroll', handleScroll);

        return () => {
            if (!listRef.current) return;

            listRef.current.removeEventListener('scroll', handleScroll);
        }
    }, []);

    function handleScroll() {
        if (!listRef.current) return;

        const children = document.querySelectorAll('[data-type="emoji-list-item"]');
        const listRect = listRef.current.getBoundingClientRect();

        children?.forEach((child) => {
            const childRect = child.getBoundingClientRect();

            if (childRect.top <= (listRect.top + 45)) {
                onChangeCategory(child.getAttribute('data-emoji-category'))
            }
        })
    }

    return (
        <>
            {!!emojiList
                ? <ul
                    ref={listRef}
                    className="emoji-picker-smileys container-scroll"
                >
                    {Object.entries(emojiList).map(([categoryName, categoryEmoji]) => (
                        (filteredEmoji?.[categoryName].length || !filteredEmoji) &&
                        <EmojiListItem
                            key={categoryName}
                            category={categoryName}
                            emojiList={categoryEmoji}
                            filteredEmoji={filteredEmoji?.[categoryName] || []}
                            onSelectEmoji={onSelectEmoji}
                            onChangeCategory={onChangeCategory}
                        />
                    ))}
                </ul>
                : <p>{get('label.find.nothing')}</p>
            }
        </>
    );
};

export default EmojiList;
